import { render } from "./SearchLotto.vue?vue&type=template&id=47ca64ed&scoped=true"
import script from "./SearchLotto.vue?vue&type=script&lang=js"
export * from "./SearchLotto.vue?vue&type=script&lang=js"

import "./SearchLotto.vue?vue&type=style&index=0&id=47ca64ed&scoped=true&lang=scss"

import exportComponent from "D:\\Work\\renny\\rotto-sale\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ca64ed"]])

export default __exports__